import Ripple from 'vuetify/lib/directives/ripple';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"video-card",attrs:{"to":_vm.to}},[_c('article',{directives:[{def: Ripple,name:"ripple",rawName:"v-ripple"}],staticClass:"elevation-1"},[_c('img',{attrs:{"src":_vm.img,"alt":_vm.title}}),_c('div',{staticClass:"legend"},[_c('time',{attrs:{"datetime":_vm.date}},[_vm._v(_vm._s(_vm.time))]),_c('h5',[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }